<template>
  <div class="maintenance-overlay" v-if="visible">
    <div class="maintenance-box">
      <div class="maintenance-icon">🔧</div>
      <h2>系统维护中</h2>
      <p class="maintenance-desc">平台正在进行系统升级维护，请稍后再试。</p>
      <p class="maintenance-sub">We'll be back soon.</p>
      <button class="maintenance-retry" @click="$emit('retry')">重新加载</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenanceOverlay',
  props: {
    visible: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.maintenance-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #0d0d1a;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.maintenance-box {
  text-align: center;
  color: #fff;
}
.maintenance-icon {
  font-size: 64px;
  margin-bottom: 24px;
}
.maintenance-box h2 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #fff;
}
.maintenance-desc {
  font-size: 16px;
  color: #b0b0c0;
  margin-bottom: 8px;
}
.maintenance-sub {
  font-size: 14px;
  color: #666;
  margin-bottom: 32px;
}
.maintenance-retry {
  background: #e64340;
  color: #fff;
  border: none;
  padding: 10px 32px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.maintenance-retry:hover {
  background: #c53530;
}
</style>
